<template>
  <div class="idquery login_common">
    <nav-top :navTitle="nav_title"/>
    <div class="section">
        <div class="userName">
            {{ name }} 님의 아이디 정보입니다.
        </div>
        <div class="userInfo flex_column_center">
            <div class="userImage">
              <img src="@/assets/icon/logo_2.png" />
            </div>
          <div class="userEmail">
              <div>
                <p class="product_type" v-for="username in usernames" :key="username">
                  {{ username }}
                </p>
              </div>
          </div>
        </div>

        <div @click="toLogin" class="login_btn">
            <div class="btn_big flex_center">
                로그인
            </div>
        </div>
        <div @click="toGetbackPwd" class="getbackpwd_btn">
          <div class="btn_check_big flex_center">
            비밀번호 찾기
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import NavTop from '@/components/navTop'
  import waves from '@/directive/waves'
	export default {
		name: 'Findid',
    directives: { waves },
    components: { NavTop },
    data () {
		  return {
        nav_title: '아이디 조회',
        name: '',
        usernames: []
      }
    },
    created () {
      if (this.$route.params.name != undefined) {
        let localName = this.$route.params.name.substr(0,1)
        for(let i = 1; i < this.$route.params.name.length; i++) {
          localName += '*'
        }

        this.name = localName
        this.usernames = this.$route.params.usernames
      }
    },
    methods: {
      toLogin () {
        this.$router.replace({ name: 'login' })
      },
      toGetbackPwd () {
        this.$router.replace({ name: 'findaccount' , params: { tabIndex: 2 }})
      }
    }
	}
</script>

<style scoped>
  .idquery{
    background-color: #F8F7F4;
  }

  .section{
    padding: 1.667rem 0 0 0;
    margin:0 1.042rem;
  }

  .userName{
    padding: 1.667rem 1.375rem 1.111rem 1.375rem;
    text-align: center;

  }

  .userInfo{
    padding: 1rem 0;
    border: 1px solid #C8C8C8;
    border-radius: 10px;
  }

  .userInfo .userImage{
    width: 2rem;
    height: 2rem;
  }

  .userImage img {
    width: 100%;
    height: 100%;
  }

  .userEmail{
    padding: .45rem 0 0 0;
  }

  .userEmail > div {
    font-size: 0.45rem;
  }

  .login_btn{
    margin: 0.833rem 0 0.278rem 0 ;
  }

  .getbackpwd_btn{
    border: 1px solid #C8C8C8;
    border-radius: 0.13889rem;
  }

  .btn_big{
    margin: 0;
  }

  .btn_check_big{
    margin: 0;
  }

  .product_type {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/views/Account/Findid.vue